var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.22797 13.4883C10.6676 13.4883 13.4559 10.6927 13.4559 7.24416C13.4559 3.7956 10.6676 1 7.22797 1C3.78836 1 1 3.7956 1 7.24416C1 10.6927 3.78836 13.4883 7.22797 13.4883Z",
    stroke: "#888888",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2282 16.7367L12.292 13.7929C11.8865 13.3863 11.8865 12.7272 12.292 12.3213C12.6976 11.9148 13.355 11.9148 13.7598 12.3213L16.6959 15.2651C17.1014 15.6717 17.1014 16.3308 16.6959 16.7367C16.2904 17.1432 15.633 17.1432 15.2282 16.7367Z",
    stroke: "#888888",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2933 12.321L11.629 11.6567",
    stroke: "#888888",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.4f7fa882e084f0f1c22669b8c2222000.svg";
export { ForwardRef as ReactComponent };